/**
 * Donut Charts Container Component
 *
 * Container that displays both New vs Returning and Booking Type donut charts
 * side by side, matching the design layout.
 */

import React from 'react';
import { NewVsReturningChart } from './NewVsReturningChart';
import { BookingTypeChart } from './BookingTypeChart';
import styles from './DonutChartsContainer.module.scss';

export const DonutChartsContainer: React.FC = () => {
    return (
        <div className={styles.chartsContainer + ' ' + styles.bookingsDonutChartsContainer}>
            {/* New vs Returning Clients Chart */}
            <div className={styles.chartWrapper}>
                <NewVsReturningChart />
            </div>

            {/* Online vs Business Booking Chart */}
            <div className={styles.chartWrapper}>
                <BookingTypeChart />
            </div>
        </div>
    );
};
